import Vue from "vue";

const queue = new Map();

/**
 * Popis tridy task:
 * {
 *   id: number,
 *   name: string
 * }
 *
 * @type {{nextid: number, count: number, queue: {}}}
 */
const state = {
  /**
   * Počet aktivních úloh
   */
  count: 0,
  /**
   * ID pro další operaci.
   */
  nextid: 0
};

const actions = {
  reset({ commit }) {
    commit("reset");
  },

  add({ commit, state }, name) {
    var tid = state.nextid++;
    commit("add", { id: tid, task: { id: tid, name: name } });
    return tid;
  },

  remove({ commit }, id) {
    commit("remove", { id: id });
  }
};

const mutations = {
  reset(state) {
    queue.clear()
    Vue.set(state, "count", 0);
  },

  add(state, params) {
    queue.set(params.id, params.task);
    Vue.set(state, "count", queue.size);
  },

  remove(state, params) {
    queue.delete(params.id);
    Vue.set(state, "count", queue.size);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};